/**
 * Date-extensions locale Estonian [et]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('et', {
    monthNames: ['Jaanuar','Veebruar','Märts','Aprill','Mai','Juuni','Juuli','August','September','Oktoober','November','Detsember'],
    monthShortNames: ['Jaan','Veebr','Märts','Apr','Mai','Juuni','Juuli','Aug','Sept','Okt','Nov','Dets'],
    dayNames: ['Pühapäev','Esmaspäev','Teisipäev','Kolmapäev','Neljapäev','Reede','Laupäev'],
    dayShortNames: ['P','E','T','K','N','R','L']
});
